<template>
  <v-container grid-list-md text-center>
    <v-row wrap>
      <v-col xs12>
        <h2>{{ this.getConfigItem("CANCEL_CONFIRM_TEXT") }}</h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col xs12>
        <h3 :style="{ color: this.getConfigItem('WARNING_COLOUR') }">
          {{ this.getConfigItem("CANCEL_INFO_TEXT") }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs12>
        <h3
          v-if="this.getConfigItem('SHOW_WAIT_TIMES', true)"
          class="text-xs-center"
        >
          {{ this.getConfigItem("WAIT_TIME_TEXT") }}
          <b>
            <span
              :style="{ color: this.getConfigItem('HIGHLIGHTED_COLOUR_TEXT') }"
            >
              {{ waitTimeEst | getShortFormattedWaitTime }}
            </span></b
          >
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        xs6
        class="text-xs-center"
        v-if="this.getConfigItem('SHOW_INFO_BUTTON_CANCEL', true)"
      >
        <v-btn
          tile
          color="info"
          :style="{ color: this.getConfigItem('INFO_COLOUR_TEXT') }"
          @click="backToEnqueueInfo()"
          class="cancel-btn"
          >{{ this.getConfigItem("BTN_DONT_CANCEL1_TEXT") }}<br />
          {{ this.getConfigItem("BTN_DONT_CANCEL2_TEXT") }}
        </v-btn>
      </v-col>
      <v-col xs6 class="text-xs-center" v-else>
        <v-btn
          tile
          color="warning"
          :style="{ color: this.getConfigItem('WARNING_COLOUR_TEXT') }"
          @click="backToEnqueueInfo()"
          class="cancel-btn"
          >{{ this.getConfigItem("BTN_DONT_CANCEL1_TEXT") }}<br />
          {{ this.getConfigItem("BTN_DONT_CANCEL2_TEXT") }}
        </v-btn>
      </v-col>
      <v-col
        xs6
        class="text-xs-center"
        v-if="this.getConfigItem('SHOW_INFO_BUTTON_CANCEL', true)"
      >
        <v-btn
          tile
          color="warning"
          :style="{ color: this.getConfigItem('WARNING_COLOUR_TEXT') }"
          @click="cancelTicket()"
          class="cancel-btn"
          >{{ this.getConfigItem("BTN_CANCEL_TICKET1_TEXT") }}<br />
          {{ this.getConfigItem("BTN_CANCEL_TICKET2_TEXT") }}
        </v-btn>
      </v-col>
      <v-col xs6 class="text-xs-center" v-else>
        <v-btn
          tile
          color="secondary"
          :style="{ color: SECONDARY_COLOUR_TEXT }"
          @click="cancelTicket()"
          class="cancel-btn"
          >{{ this.getConfigItem("BTN_CANCEL_TICKET1_TEXT") }}<br />
          {{ this.getConfigItem("BTN_CANCEL_TICKET2_TEXT") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { helper } from "@/helper";
import axios from "axios";
import serviceMixin from "@/mixins/serviceMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [serviceMixin],
  data: () => ({
    caseCookie: null,
    waitTimeEst: null,
  }),
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
  },
  mounted: function () {
    this.caseCookie = helper.getCaseCookie();

    if (this.caseCookie) {
      this.callGetService(
        this,
        "/Cases/" + this.caseCookie.CaseId,
        null,
        (response) => {
          this.waitTimeEst = response.data.WaitTimeEst;
        },
        null,
        this.getConfigItem("CHECK_COOKIE_TICKET_TEXT")
      );
    }
  },
  methods: {
    backToEnqueueInfo() {
      this.$router.push("EnqueueInfo");
    },
    cancelTicket() {
      this.$root.showLoading();

      var isPostToCancelCase = this.getConfigItem("POST_TO_CANCEL_CASE", true);
      if (!isPostToCancelCase) {
        axios
          .patch("/Cases/", {
            CaseId: this.caseCookie.CaseId,
            Status: 15,
          })
          .then(
            () => {
              helper.deleteCaseCookie();
              this.$router.push("CancelEnqueueSuccess");
            },
            (error) => {
              console.log(error);
              let errorMessage = "";
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.Message
              ) {
                errorMessage = error.response.data.Message;
              }
              let errorInfo =
                this.getConfigItem("APT_ERR_DEFAULT1_TEXT") +
                " " +
                this.getConfigItem("APT_ERR_DEFAULT3_TEXT");

              helper.deleteCaseCookie();
              this.$root.showError(errorMessage, errorInfo);
            }
          )
          .then(() => {
            this.$root.hideLoading();
          });
      } else {
        axios
          .post("/Cases/Cancel/", {
            CaseId: this.caseCookie.CaseId,
            Status: 15,
          })
          .then(
            () => {
              helper.deleteCaseCookie();
              this.$router.push("CancelEnqueueSuccess");
            },
            (error) => {
              console.log(error);
              let errorMessage = "";
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.Message
              ) {
                errorMessage = error.response.data.Message;
              }
              let errorInfo =
                this.getConfigItem("APT_ERR_DEFAULT1_TEXT") +
                " " +
                this.getConfigItem("APT_ERR_DEFAULT3_TEXT");

              helper.deleteCaseCookie();
              this.$root.showError(errorMessage, errorInfo);
            }
          )
          .then(() => {
            this.$root.hideLoading();
          });
      }
    },
  },
};
</script>
